import { STANDARD } from 'constants/customLayouts';

const selectLayout = state =>
  state.account?.online_ordering_general_settings?.layout ?? STANDARD;

export default selectLayout;
